<template>
    <router-view/>
    <CopyrightFooter />
</template>

<script>
export default {
  head: {
    link :[
      {
        rel: "icon",
        href: require("./assets/icon.png")
      }
    ]
  }
}
</script>

<style>
html {
  background-color: #181a1b;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #bbbbbb;
  background-color: #181a1b;  
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

</style>
